/**
 * Client Training / Cardio / Strength statistics — one dedicated read per
 * screen (`/v2/stats/training/overview|cardio|strength`, `to` exclusive). Mapped to the Ui
 * shapes here so the screens never see Api types.
 */
import type {
  FetchExerciseStatisticsArgs,
  FetchTrainingStatisticsArgs,
  ApiExerciseStatistics,
  ApiExerciseListItem,
  ClientScopeArgs,
  ApiStrengthStatistics,
  ApiTrainingOverview,
  ApiCardioStatistics,
} from './types/stats.types';

import {
  mapExerciseStatisticsFromApi,
  mapStrengthStatisticsFromApi,
  mapTrainingOverviewFromApi,
  mapCardioStatisticsFromApi,
} from './mappers/trainingStats.mappers';
import { get } from './axios';

const query = (args: FetchTrainingStatisticsArgs) => ({
  clientId: args.clientId,
  from: args.from,
  to: args.to,
});

export const fetchCardioStatistics = async (
  args: FetchTrainingStatisticsArgs,
) => {
  const response = await get<ApiCardioStatistics>('/v2/stats/training/cardio', {
    query: query(args),
  });
  return response ? mapCardioStatisticsFromApi(response) : null;
};

export const fetchStrengthStatistics = async (
  args: FetchTrainingStatisticsArgs,
) => {
  const response = await get<ApiStrengthStatistics>(
    '/v2/stats/training/strength',
    { query: query(args) },
  );
  return response ? mapStrengthStatisticsFromApi(response) : null;
};

export const fetchTrainingOverview = async (
  args: FetchTrainingStatisticsArgs,
) => {
  const response = await get<ApiTrainingOverview>(
    '/v2/stats/training/overview',
    { query: query(args) },
  );
  return response ? mapTrainingOverviewFromApi(response) : null;
};

export const fetchExercises = async (args: ClientScopeArgs) => {
  const response = await get<ApiExerciseListItem[]>(
    '/v2/stats/training/exercises',
    { query: { clientId: args.clientId } },
  );
  return response ?? [];
};

export const fetchExerciseStatistics = async ({
  clientId,
  exerciseId,
}: FetchExerciseStatisticsArgs) => {
  const response = await get<ApiExerciseStatistics>(
    `/v2/stats/training/exercises/${exerciseId}`,
    { query: { clientId } },
  );
  return response ? mapExerciseStatisticsFromApi(response) : null;
};
